<template>
  <div class="colors">{{ colors }}</div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "colors",

  data() {
    return {
      colors: []
    };
  },
  mounted: function() {
    var self = this;
    const colorsRef = firebase
      .firestore()
      .collection("colors")
      .doc("0");
    colorsRef
      .get()
      .then(function(doc) {
        if (doc.exists) {
          let c = doc.data();
          for (const i of c["knotty-colors"]) {
            i.show = true;
          }
          function isKnotty(color) {
            return color.colorSet == "Knotty";
          }
          const knottyColors = c["knotty-colors"];
          self.colors = knottyColors;
          setTimeout(() => {
            self.changed = false;
          }, 500);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function(error) {
        console.log("Error getting document:", error);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Colors.vue